import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';
import Home from './Home';
import Landing from './Landing';

/**
 * Smart router component that shows:
 * - Landing page for unauthenticated users
 * - Home dashboard for authenticated users
 */
export default function HomeOrLanding() {
  const { user, loading } = useAuth();

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background w-full max-w-full overflow-x-hidden">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  // Show landing page for unauthenticated users
  if (!user) {
    return <Landing />;
  }

  // Show home dashboard for authenticated users
  return <Home />;
}
